import * as React from "react";
import { useStoreFinderContext, Hooks, Components } from "@grandvisionhq/stores-v2";
const { StoreFinderClickableItem, StoreFinderItem } = Components;
const { useFormattedDistance } = Hooks;
const StoreFinderItemContainer = ({ onClick, variant, store, ...rest }) => {
  const { setHoveredStore } = useStoreFinderContext();
  const distance = useFormattedDistance(store?.distance);
  const onClickHandler = React.useCallback(() => {
    store && onClick(store);
  }, [store, onClick]);
  const onMouseEnterHandler = React.useCallback(() => {
    if (store?.globalStoreId) {
      setHoveredStore(store);
    }
  }, [setHoveredStore, store]);
  const onMouseLeaveHandler = React.useCallback(() => {
    setHoveredStore(null);
  }, [setHoveredStore]);
  if (!store) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StoreFinderClickableItem,
    {
      ...rest,
      className: "service-store__list-item",
      onClick: onClickHandler,
      onMouseEnter: onMouseEnterHandler,
      onMouseLeave: onMouseLeaveHandler,
      variant
    },
    /* @__PURE__ */ React.createElement(
      StoreFinderItem,
      {
        addressSize: "MINIMAL",
        showAttributesAs: "icons",
        store: {
          ...store,
          wheelchairAccessible: false,
          hearingAppointmentPossible: false,
          isFranchiseStore: false,
          storeNote: void 0
        },
        distance,
        showEmailAddress: false,
        showPhone: false,
        showOpeningHours: false
      }
    )
  );
};
export {
  StoreFinderItemContainer
};
//# sourceMappingURL=StoreFinderItemContainer.js.map
